var map = {
	"./favicon.png": "8925e",
	"./horizontal.jpg": "819e",
	"./logo.png": "9d64",
	"./logo_login-1.png": "f840",
	"./logo_login.png": "ff4a",
	"./user.png": "ba97",
	"./user1.png": "b4ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";